<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import CustomerFieldErrorMessageMixin from './mixins/customer_field_error_message';

export default {
  mixins: [CustomerFieldErrorMessageMixin],

  props: {
    name: {
      type: String,
      required: true
    },

    autocomplete: {
      type: String,
      required: false,
      default: 'on'
    },

    withLabel: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  emits: ['changed'],

  data() {
    return {
      arrowUp: false,
    };
  },

  computed: {
    ...mapState({
      input(state) {
        return state.inputs[this.name];
      },
      error(state) {
        return state.inputs[this.name].error;
      }
    }),

    value: {
      get() {
        return this.input.value || '';
      },

      set(value) {
        this.arrowUp = false;

        this.setValue({
          name: this.name,
          value
        });

        this.validateField(this.name);

        this.$emit('changed');
      }
    },

    errorClass() {
      return {
        'c-form__field--error': this.error
      };
    },

    arrowClass() {
      return {
        'c-form__select--arrow': true,
        'c-form__select--arrow-up': this.arrowUp
      };
    },

    labelFor() {
      return `payment_page_${this.name}`;
    },

    labelText() {
      return this.t(`pay.js.marketing.payment_information.inputs.${this.name}`);
    }
  },

  methods: {
    selectClicked() {
      this.arrowUp = true;
    },

    selectFocusedOut() {
      this.arrowUp = false;
    },

    ...mapActions([
      'validateField'
    ]),

    ...mapMutations({
      setValue: 'setInputValue'
    }),
  }
};
</script>

<template>
  <div :class="errorClass">
    <div class="c-form__select">
      <label
        v-if="withLabel"
        :for="labelFor"
      >
        {{ labelText }}
      </label>

      <select
        :id="labelFor"
        v-model="value"
        :name="input.name"
        :autocomplete="autocomplete"
        @click="selectClicked"
        @focusout="selectFocusedOut"
      >
        <slot />
      </select>

      <div :class="arrowClass" />
    </div>

    <div class="c-form__feedback">
      {{ errorMessage }}
    </div>
  </div>
</template>
